module.exports = __webpack_public_path__ + "img/gift-light.c0508363.png";